"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.regexp.replace");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var client_library_1 = require("@seneca/client-library");

var cdn_1 = require("./utils/cdn");

var giphy_1 = require("./utils/giphy");

var consts_1 = require("./consts");

var GIPHY_REPLACEMENT_URL = 'https://gif.app.senecalearning.com/media/$1/giphy.mp4';

var ImageServiceClient = /*#__PURE__*/function (_client_library_1$Cli) {
  _inherits(ImageServiceClient, _client_library_1$Cli);

  var _super = _createSuper(ImageServiceClient);

  function ImageServiceClient(fetch, options) {
    var _this;

    _classCallCheck(this, ImageServiceClient);

    _this = _super.call(this, fetch, options);

    if (!options.cdnBaseUrl) {
      throw new client_library_1.MissingParamError('cdnBaseUrl needs to be provided in options');
    }

    _this._cdnBaseUrl = options.cdnBaseUrl;
    return _this;
  }
  /**
   * Given a url with a cdn protocol returns a url for an image that conforms to some options.
   * If this function is given a non CDN url it will simple return it to preserve backward compatibility
   * If the url matches a Giphy url - it will be replaced by a proxy url that will route to the same asset
   */


  _createClass(ImageServiceClient, [{
    key: "getImageUrl",
    value: function getImageUrl(baseUrl) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (giphy_1.isGiphyUrl(baseUrl)) {
        return baseUrl.replace(giphy_1.GIPHY_REG_EX, GIPHY_REPLACEMENT_URL);
      }

      if (!baseUrl.startsWith(consts_1.CDN_URL_PROTOCOL)) {
        return baseUrl;
      }

      return cdn_1.parseCdnUrl(baseUrl, this._cdnBaseUrl, options);
    }
  }, {
    key: "uploadImage",
    value: function uploadImage(image, contentType, fileName) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var body, uploadBody, putRes;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!image || !image.data || !image.size)) {
                  _context.next = 2;
                  break;
                }

                throw new client_library_1.MissingParamError('image.size and image.data must be provided');

              case 2:
                if (contentType) {
                  _context.next = 4;
                  break;
                }

                throw new client_library_1.MissingParamError('contentType must be provided');

              case 4:
                body = {
                  contentType: contentType,
                  fileName: fileName
                };
                _context.next = 7;
                return this._makeImageRequest('api/upload-url', 'POST', body, undefined, [201]);

              case 7:
                uploadBody = _context.sent;
                _context.next = 10;
                return this.requestMaker.fetch(uploadBody.uploadUrl, {
                  method: 'PUT',
                  headers: {
                    'Content-Length': image.size,
                    'Content-Type': contentType
                  },
                  body: image.data
                });

              case 10:
                putRes = _context.sent;

                if (putRes.ok) {
                  _context.next = 13;
                  break;
                }

                throw new client_library_1.UnexpectedServerResponse('PUT', uploadBody.uploadUrl, putRes.status);

              case 13:
                return _context.abrupt("return", cdn_1.getCdnUrl(uploadBody.fetchUrl));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "_makeImageRequest",
    value: function _makeImageRequest(path, method, body, queryParams, expectedResponses) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var url, queryParamParts, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = "".concat(this.url, "/").concat(path);

                if (queryParams) {
                  queryParamParts = [];
                  Object.keys(queryParams).forEach(function (param) {
                    if (queryParams[param]) {
                      queryParamParts.push("".concat(param, "=").concat(queryParams[param]));
                    }
                  });
                  url += "?".concat(queryParamParts.join('&'));
                }

                _context2.next = 4;
                return this.requestMaker.makeRequest(url, {
                  method: method,
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: body ? JSON.stringify(body) : undefined
                }, expectedResponses);

              case 4:
                response = _context2.sent;
                return _context2.abrupt("return", response.json);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return ImageServiceClient;
}(client_library_1.Client);

exports["default"] = ImageServiceClient;